// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"78fd7858","977":"8b6f2a44"}[chunkId] + ".chunk.js";
};